import React from 'react';
import { cn } from '../lib/utils';

export interface LoadingSkeletonProps {
  lines?: number;
  rows?: number;
  className?: string;
  compact?: boolean;
}

export function LoadingSkeleton({ lines, rows, className, compact = false }: LoadingSkeletonProps) {
  const count = lines ?? rows ?? 3;
  return (
    <div
      role="status"
      aria-label="Loading"
      className={cn(compact ? 'space-y-2' : 'space-y-3', className)}
    >
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className={cn(
            compact ? 'h-3' : 'h-4',
            'experience-candidate-skeleton experience-candidate-motion animate-pulse rounded-full bg-gradient-to-r from-slate-200 via-slate-100 to-slate-200 shadow-[inset_0_1px_0_rgba(255,255,255,0.6)]',
            i === 1 && count > 2 ? 'w-11/12' : '',
            i === count - 1 && count > 1 ? 'w-2/3' : i > 1 ? 'w-5/6' : 'w-full',
          )}
        />
      ))}
    </div>
  );
}
